import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/responsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import our i18n configuration
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Use Suspense for i18next to make sure translations are loaded before rendering
root.render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
